import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopUpComponent = _resolveComponent("PopUpComponent")!

  return (_openBlock(), _createBlock(_Transition, {
    name: _ctx.popUpData.type === 'danger' ? 'shake' : 'fade',
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.isPopUpExists)
        ? (_openBlock(), _createBlock(_component_PopUpComponent, {
            key: _ctx.popUpData.id,
            type: _ctx.popUpData.type,
            title: _ctx.popUpData.title,
            desc: _ctx.popUpData.desc,
            duration: _ctx.popUpData.duration
          }, null, 8, ["type", "title", "desc", "duration"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name"]))
}